import types from '../../mutation-types';

export const mutations = {
  [types.SET_PAYMENT_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.CLEAR_PAYMENTS]: $state => {
    $state.records = {};
    $state.sortOrder = [];
  },

  [types.SET_PAYMENT_META]: ($state, data) => {
    const { count, current_page: currentPage } = data;
    $state.meta.count = count;
    $state.meta.currentPage = currentPage;
  },

  [types.SET_PAYMENTS]: ($state, data) => {
    const sortOrder = data.map(payment => {
      $state.records[payment.id] = {
        ...($state.records[payment.id] || {}),
        ...payment,
      };
      return payment.id;
    });
    $state.sortOrder = sortOrder;
  },

  [types.ADD_PAYMENT]: ($state, data) => {
    $state.records[data.id] = {
      ...($state.records[data.id] || {}),
      ...data,
    };

    if (!$state.sortOrder.includes(data.id)) {
      $state.sortOrder.unshift(data.id);
    }
  },

  [types.EDIT_PAYMENT]: ($state, data) => {
    if ($state.records[data.id]) {
      $state.records[data.id] = {
        ...$state.records[data.id],
        ...data,
      };
    }
  },
};
